<template>
	<div>
		<topback title="Account Info" path="/my"></topback>
		<div class="user_avatar">
			<img src="/static/images/avatar.png" alt="" />
		</div>

		<div class="accountinfo-action">
			<md-field>
				<md-cell-item title="ID:">
					<span slot="right">{{ $store.state.userinfo.collectionworkerid }}
						<md-icon class="icon-edit copy" name="edit" size="md" :data-clipboard-text="$store.state.userinfo.collectionworkerid" @click="onCopy"></md-icon>
					</span>
				</md-cell-item>

				<md-cell-item title="Phone:">
					<span slot="right">{{ $store.state.userinfo.phone }}
						<md-icon class="icon-edit copy" name="edit" size="md" :data-clipboard-text="$store.state.userinfo.phone" @click="onCopy"></md-icon>
					</span>
				</md-cell-item>
				<md-cell-item title="Security">
					<span slot="right">********
						<md-icon class="icon-edit" name="edit" size="md" @click="go_editpassword"></md-icon>
					</span>
				</md-cell-item>
			</md-field>


		</div>
	</div>

</template>

<script>
import topback from '@/components/topback'
import { Field, CellItem } from 'mand-mobile'
import Clipboard from "clipboard"

export default {
	name: 'AcountInfo',

	components: {
		[topback.name]: topback,
		[Field.name]: Field,
		[CellItem.name]: CellItem,

	},

	data() {
		return {
			verifyKYC: this.isVerifyKYC() ? 'Verified' : 'Not Verified',

		}
	},

	methods: {
		isVerifyKYC() {
			return true
		},
		onCopy() {
			let clipboard = new Clipboard('.copy')
			clipboard.on('success', () => {
				this.$toast.succeed('copy successfully');
				clipboard.destroy()
			})
			clipboard.on('error', () => {
				this.$toast.failed("Browser does not support copying")
				clipboard.destroy()
			});
		},
		go_editpassword() {
			this.$router.push('/editpassword');
		}
	}
}

</script>
<style lang="stylus" scoped>
.user_avatar
 text-align center
 margin-top 1.5rem
 img 
  display block
  width 176px
  height 176px
  border-radius 88px
  background-color #E6E6E6
  margin-left 38%
  text-align center
.user-detial
 font-size 50px
.accountinfo-action
 text-align left
 .icon-edit
  padding-left 10px !important
  margin-left 15px !important
</style>


// WEBPACK FOOTER //
// src/views/my/accountInfo.vue